import { coordEq, effectiveAttackKind, isIndirectFire } from "@dailywars/core/engine";
import type { Coord, GameState, Unit } from "@dailywars/core/engine";

import type { AttackOption } from "#/game/selection/types";

export function attackCursorForUnit(unit: Unit): "attack" | "attack-indirect" {
  return isIndirectFire(effectiveAttackKind(unit)) ? "attack-indirect" : "attack";
}

export function findSelectedUnit(state: GameState, unitId: string): Unit | undefined {
  return state.units.find((u) => u.id === unitId);
}

export function isAttackableEnemy({
  attackOptions,
  hoveredUnit,
  hoveredEnemy,
}: {
  attackOptions: AttackOption[];
  hoveredUnit: Unit | undefined;
  hoveredEnemy: boolean;
}): boolean {
  return Boolean(
    hoveredEnemy && hoveredUnit && attackOptions.some((o) => o.targetId === hoveredUnit.id),
  );
}

export function isFriendlyUnit(hoveredUnit: Unit | undefined, currentPlayer: string): boolean {
  return Boolean(hoveredUnit && hoveredUnit.owner === currentPlayer);
}

export function hasOptionForUnit<T extends { targetId: string }>(
  options: T[],
  hoveredUnit: Unit | undefined,
): boolean {
  return Boolean(hoveredUnit && options.some((o) => o.targetId === hoveredUnit.id));
}

export function isReachableTile(reachable: Coord[], hoveredTile: Coord): boolean {
  return reachable.some((c) => coordEq(c, hoveredTile));
}
